import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Divider, Grid, Typography, Paper, Accordion, AccordionDetails, AccordionSummary } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import format from 'date-fns/format';
import { FormattedMessage, injectIntl } from 'react-intl';
import classNames from 'classnames';
import messages from 'aurora-translations';
import { keyEmptyCheck } from 'aurora-utils/utils';
import { ADGMImage } from 'aurora-components';
import { useSelector } from 'react-redux';
import Skeleton from '@material-ui/lab/Skeleton';
import styles from './style';

function SkeletonLoader() {
  return Array.from(new Array(5)).map((_, index) => (
    /* eslint-disable react/no-array-index-key */
    <Skeleton
      key={index}
      variant='rectangular'
      animation='wave'
      width='100%'
      height={30}
      style={{
        borderRadius: 4,
        marginBottom: index === 4 ? 0 : 10,
      }}
    />
  ));
}
function ApplicationHistory({ classes, workflowHistory, intl }) {
  const { workflowHistoryLoading } = useSelector(state => state.LeaseApplicationReducer);
  const locale = localStorage.getItem('lang');
  const userNm = locale === 'ar' ? localStorage.getItem('UserNameAr') : localStorage.getItem('UserNameEn');

  const getMappedObj = data => {
    const mappedData = {};
    data.forEach(item => {
      const keyNm =
        locale === 'en'
          ? `${item.taskAssigneeNameEn}_${item.taskAssignedUserId}`
          : `${item.taskAssigneeNameAr}_${item.taskAssignedUserId}`;
      if (mappedData[keyNm]) {
        mappedData[keyNm] = [...mappedData[keyNm], item];
      } else {
        mappedData[keyNm] = [item];
      }
    });
    return mappedData;
  };
  if (workflowHistoryLoading) return <SkeletonLoader />;
  return (
    <>
      <div className={classes.paperCardFrame}>
        <div className={classes.titleHead}>
          <Typography className={classes.Title}>
            <FormattedMessage {...messages.application_history} />
          </Typography>
        </div>

        {workflowHistory?.length > 0 && (
          <Paper variant='outlined' className={classes.innerCardPaper}>
            <Grid container spacing={3} className={classNames(classes.innerCardGrid)}>
              <ul className={classes.applicationDetailsListNew}>
                {workflowHistory &&
                  workflowHistory?.map((history, index) => {
                    return history?.applicationTaskHistoryList?.length === 0 ? (
                      <li
                        className={
                          history?.stageStatus === 'COMPLETED' ? classes.completeStage : classes.inCompleteStage
                        }
                      >
                        <Typography
                          variant='body1'
                          className={classNames(
                            classes.title,
                            classes.font16,
                            classes.mt8,
                            history?.stageStatus !== 'COMPLETED' ? classes.fontW600 : '',
                          )}
                        >
                          {history?.stage === 'PAYMENT'
                            ? history?.stageStatus !== 'COMPLETED'
                              ? keyEmptyCheck('pending_for_payment')
                              : keyEmptyCheck('payment_completed')
                            : keyEmptyCheck(history?.stage)}
                        </Typography>
                        {history?.stepType !== 'ADMIN' && index === 0 && (
                          <Typography
                            variant='body1'
                            className={classNames(classes.subTitle, classes.font14, classes.mt8)}
                          >
                            {keyEmptyCheck('by')}
                            {locale === 'en' ? ` ${history?.initiatorName} ` : ` ${history?.initiatorNameAr}`}
                            {history?.initiatorName?.toLowerCase() === userNm?.toLowerCase() ||
                            history?.initiatorNameAr?.toLowerCase() === userNm?.toLowerCase()
                              ? `(${intl.formatMessage({ ...messages.you })})`
                              : ''}
                          </Typography>
                        )}

                        <Typography
                          variant='body1'
                          className={classNames(classes.font12, classes.lightClr, classes.mt8, classes.timeWrapper)}
                        >
                          <span className={classes.timeClsWrapper}>
                            <ADGMImage name='calendorIcon.svg' alt='calendor_icon' className={classes.iconCls} />
                          </span>
                          <span className={classes.timeCls}>
                            {keyEmptyCheck('last_update')}
                            {': '}
                            {history?.lastUpdatedDate && history?.lastUpdatedDate !== null
                              ? format(new Date(history?.lastUpdatedDate), 'dd/MM/yyyy - hh:mma')
                              : '-'}
                          </span>
                        </Typography>
                        <Divider className={classes.dividerFirstCls} />
                      </li>
                    ) : (
                      <li
                        className={classNames(
                          classes.accordianLi,
                          history?.stageStatus === 'COMPLETED' ? classes.completeStage : classes.inCompleteStage,
                        )}
                      >
                        <Accordion className={classes.accordian} defaultExpanded={history?.stageStatus !== 'COMPLETED'}>
                          <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls='panel1bh-content'
                            id='panel1bh-he ader'
                            className={classes.accordianSummary}
                          >
                            <div>
                              <Typography
                                className={classNames(
                                  classes.title,
                                  history?.stageStatus !== 'COMPLETED' ? classes.fontW600 : '',
                                )}
                              >
                                {history?.stage === 'PAYMENT'
                                  ? history?.stageStatus !== 'COMPLETED'
                                    ? keyEmptyCheck('pending_for_payment')
                                    : keyEmptyCheck('payment_completed')
                                  : keyEmptyCheck(history?.stage)}
                              </Typography>
                            </div>
                            <div>
                              <Typography
                                variant='body1'
                                className={classNames(
                                  classes.font12,
                                  classes.lightClr,
                                  classes.mt8,
                                  classes.timeWrapper,
                                )}
                              >
                                <span className={classes.timeClsWrapper}>
                                  <ADGMImage name='calendorIcon.svg' alt='calendor_icon' className={classes.iconCls} />
                                </span>
                                <span className={classes.timeCls}>
                                  {keyEmptyCheck('last_update')}
                                  {': '}
                                  {history?.lastUpdatedDate && history?.lastUpdatedDate !== null
                                    ? format(new Date(history?.lastUpdatedDate), 'dd/MM/yyyy - hh:mma')
                                    : '-'}
                                </span>
                              </Typography>
                            </div>
                          </AccordionSummary>
                          <AccordionDetails>
                            <ul>
                              {Object.entries(getMappedObj(history?.applicationTaskHistoryList)).map(([key, val]) => {
                                return (
                                  <li key={key}>
                                    <Divider className={classes.dividerCls} />
                                    {key && key !== 'null' && (
                                      <div
                                        className={classNames(
                                          classes.font14,
                                          classes.darkClr,
                                          classes.fontW500,
                                          classes.mt8,
                                        )}
                                      >
                                        {key.split('_')[0]}
                                      </div>
                                    )}

                                    <ul className={classes.mt8}>
                                      {val.map(item => (
                                        <li>
                                          <div className={classNames(classes.appStatus, classes.lightClr)}>
                                            <div className={classes.statusCls}>
                                              <span
                                                className={classNames(
                                                  classes.dotCls,
                                                  item?.taskActionType === null
                                                    ? classes.blueClr
                                                    : item?.taskActionType === 'APPROVED' ||
                                                      item?.taskActionType === 'PAID'
                                                    ? classes.greenClr
                                                    : item?.taskActionType === 'RETURNED'
                                                    ? classes.orangeClr
                                                    : classes.redClr,
                                                )}
                                              >
                                                &nbsp;
                                              </span>
                                              <span>
                                                {item?.taskActionType === null
                                                  ? keyEmptyCheck('REVIEW')
                                                  : keyEmptyCheck(item?.taskActionType)}
                                              </span>
                                            </div>
                                            <div>
                                              {' '}
                                              {item?.taskEndDate && item?.taskEndDate !== null
                                                ? format(new Date(item?.taskEndDate), 'dd/MM/yyyy - hh:mma')
                                                : item?.taskStartDate && item?.taskStartDate !== null
                                                ? format(new Date(item?.taskStartDate), 'dd/MM/yyyy - hh:mma')
                                                : '-'}
                                            </div>
                                          </div>
                                        </li>
                                      ))}
                                    </ul>
                                  </li>
                                );
                              })}
                            </ul>
                          </AccordionDetails>
                        </Accordion>
                        {workflowHistory?.length > index + 1 && <Divider className={classes.dividerFirstCls} />}
                      </li>
                    );
                  })}
              </ul>
            </Grid>
          </Paper>
        )}
      </div>
    </>
  );
}

ApplicationHistory.propTypes = {
  classes: PropTypes.object.isRequired,
  workflowHistory: PropTypes.array.isRequired,
  intl: PropTypes.object.isRequired,
};

export default withStyles(styles)(injectIntl(ApplicationHistory));
